export default {
  zh: {
    title: '备注',
    placeholder: '请输入备注',
    remove: '删除备注',
    contentRequired: '请输入待办内容'
  },
  tw: {
    title: '備註',
    placeholder: '請輸入備註',
    remove: '刪除備註',
    contentRequired: '請輸入待辦內容'
  },
  nl: {
    title: 'Opmerking',
    placeholder: 'Voer een opmerking in',
    remove: 'Opmerking verwijderen',
    contentRequired: 'Voer de inhoud van de taak in'
  },
  uk: {
    title: 'Note',
    placeholder: 'Enter a note',
    remove: 'Delete note',
    contentRequired: 'Please enter a to-do item'
  },
  us: {
    title: 'Note',
    placeholder: 'Enter a note',
    remove: 'Delete note',
    contentRequired: 'Please enter a to-do item'
  },
  fr: {
    title: 'Remarque',
    placeholder: 'Saisissez une remarque',
    remove: 'Supprimer la remarque',
    contentRequired: 'Veuillez saisir le contenu de la tâche'
  },
  de: {
    title: 'Notiz',
    placeholder: 'Notiz eingeben',
    remove: 'Notiz löschen',
    contentRequired: 'Bitte geben Sie den Inhalt der Aufgabe ein'
  },
  it: {
    title: 'Nota',
    placeholder: 'Inserisci una nota',
    remove: 'Elimina nota',
    contentRequired: 'Inserisci il contenuto dell’attività'
  },
  ja: {
    title: 'メモ',
    placeholder: 'メモを入力してください',
    remove: 'メモを削除',
    contentRequired: 'タスクの内容を入力してください'
  },
  ko: {
    title: '메모',
    placeholder: '메모를 입력하세요',
    remove: '메모 삭제',
    contentRequired: '할 일 내용을 입력하세요'
  },
  pt: {
    title: 'Observação',
    placeholder: 'Digite uma observação',
    remove: 'Excluir observação',
    contentRequired: 'Digite o conteúdo da tarefa'
  },
  ru: {
    title: 'Примечание',
    placeholder: 'Введите примечание',
    remove: 'Удалить примечание',
    contentRequired: 'Введите содержание задачи'
  },
  es: {
    title: 'Nota',
    placeholder: 'Introduce una nota',
    remove: 'Eliminar nota',
    contentRequired: 'Introduce el contenido de la tarea'
  }
}
